<!-- /* PAT-203 — maintenance lock overlay (blocks app until window ends). */ -->
@if (maintenanceActive()) {
  <div class="maintenance-overlay" role="dialog" aria-modal="true" aria-label="Maintenance in progress">
    <div class="maintenance-card">

      <!-- Brand — PAT-123 application logo lockup -->
      <div class="maintenance-brand">
        <app-pathways-logo variant="lockup" brandText="Pathways AI" />
      </div>

      <!-- Public message -->
      <div class="maintenance-body">
        <h1 class="maintenance-title">Scheduled maintenance in progress</h1>
        <p class="maintenance-subtitle">We'll be right back shortly. Thank you for your patience.</p>
        <div class="pulse-dots" aria-hidden="true">
          <span></span><span></span><span></span>
        </div>
      </div>

      <!-- Sign-in link for unauthenticated users -->
      @if (!auth.isLoggedIn()) {
        <div class="maintenance-signin">
          <a href="/" class="pathways-link">Sign in</a>
          <span>to access the admin section</span>
        </div>
      }

      <!-- Admin section — role-gated -->
      @if (auth.isAdmin() && canManageMaintenance()) {
        <div class="admin-section">
          <div class="admin-section-header">
            <i class="fa-solid fa-screwdriver-wrench" aria-hidden="true"></i>
            Admin — End Maintenance
          </div>

          <div class="admin-fields">
            <div>
              <label class="field-label" for="release-version">Version</label>
              <input
                id="release-version"
                class="field-input"
                type="text"
                placeholder="e.g. 1.2.3"
                [value]="releaseVersion()"
                (input)="onVersionInput($event)"
                [disabled]="submitting()"
              />
            </div>

            <div class="editor-row">
              <div class="editor-col">
                <label class="field-label" for="release-notes">Release notes (Markdown)</label>
                <textarea
                  id="release-notes"
                  class="field-textarea"
                  placeholder="## What's new&#10;- Feature one&#10;- Feature two"
                  rows="10"
                  [value]="releaseNotes()"
                  (input)="onNotesInput($event)"
                  [disabled]="submitting()"
                ></textarea>
              </div>
              <div class="editor-col">
                <span class="field-label">Preview</span>
                <div class="markdown-preview" [innerHTML]="previewHtml()"></div>
              </div>
            </div>

            <div class="admin-actions">
              <button
                type="button"
                class="pathways-btn-primary"
                [disabled]="!canSubmit()"
                (click)="endMaintenance()"
              >
                @if (submitting()) {
                  <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
                  Ending maintenance…
                } @else {
                  <i class="fa-solid fa-check" aria-hidden="true"></i>
                  End Maintenance
                }
              </button>
            </div>
          </div>
        </div>
      }

    </div>
  </div>
}
